import axiosInstance from '../axiosInterceptor/axiosInstance'

const getLivestreamUrl = async (orgId, streamId) => {
  const url = `v1/orgs/${orgId}/streams/${streamId}/recording/playlist`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getLivestreamUrl
